import VueRouter from "vue-router";
import Vue from "vue";
import { getStore } from "@/utils/store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
NProgress.configure({ showSpinner: false });

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        redirect: '/login',
        component: () => import("@/components/Management/login/index.vue"),
    },
    // {
    //     path: '/PriceShow',
    //     name: 'PriceShow',
    //     component: () => import('@/components/PriceShow.vue')
    // },
    {
        path: '/2k/:tenantId',
        name: '2kWithId',
        component: () => import('@/components/ShowOn2K.vue')
    },
    {
        path: '/2kmobile/:tenantId',
        name: 'PreciousMetalPrice',
        component: () => import('@/components/PreciousMetalPrice.vue')
    },
    // 自定义报价盘大屏
    {
        path: '/2k/v2/:tenantId',
        name: '2kWithId',
        component: () => import('@/components/ShowOn2K.vue')
    },
    {
        path: '/2kmobile/v2/:tenantId',
        name: 'PreciousMetalPrice',
        component: () => import('@/components/PreciousMetalPrice.vue')
    },
    // 海外版报价盘大屏
    {
        path: '/2k-en/:tenantId',
        name: '2kENWithId',
        component: () => import('@/components/ShowOn2KEN.vue')
    },
    {
        path: '/2kmobile-en/:tenantId',
        name: 'PreciousMetalPriceEN',
        component: () => import('@/components/PreciousMetalPriceEN.vue')
    },
    {
        path: '/MonitorDashboard',
        name: 'MonitorDashboard',
        component: () => import('@/components/MonitorDashboard.vue')
    },
    // {
    //     path: '/Copy',
    //     name: 'CopyConponent',
    //     component: () => import('@/components/Copy.vue')
    // },
    {
        path: "/login",
        name: "LoginPage",
        component: () => import("@/components/Management/login/index.vue"),
    },
    {
        path: "/sso",
        name: "SsoLogin",
        component: () => import("@/components/Management/login/Sso.vue"),
    },
    {
        path: "/userTenant",
        name: "UsserTenant",
        component: () => import("@/components/Management/login/userTenant.vue"),
    },
    {
        path: "/h5/tenant-manage",
        name: "TenantManageH5",
        component: () => import("@/components/Management/mobile/TenantManageH5.vue"),
    },
    {
        path: "/h5/st",
        name: "TenantTimeSourceH5",
        component: () => import("@/components/Management/mobile/TenantTimeSourceH5.vue"),
    },
    {
        path: '/management',
        redirect: '/Management/PriceManage',
        component: () => import('@/components/Management/layout/index.vue'),
        children: [
            {
                path: '/Management/PriceManage',
                name: 'PriceManageWithId',
                component: () => import('@/components/Management/PriceManage.vue')
            },
            {
                path: '/Management/TenantManage',
                name: 'TenantManage',
                component: () => import('@/components/Management/TenantManage.vue')
            },
            {
                path: '/Management/CustomBoard',
                name: 'CustomBoard',
                component: () => import('@/components/Management/CustomBoard.vue')
            },
            {
                path: '/Management/PriceOffsetScene',
                name: 'PriceOffsetScene',
                component: () => import('@/components/Management/PriceOffsetScene.vue')
            },
            {
                path: '/Management/OperationLog',
                name: 'OperationLog',
                component: () => import('@/components/Management/OperationLog.vue'),
            },
            {
                path: '/Management/DeviceManage',
                name: 'DeviceManage',
                component: () => import('@/components/Management/DeviceManage.vue'),
                meta: { requiresAdmin: true }
            },
            {
                path: '/Management/UserManage',
                name: 'UserManage',
                component: () => import('@/components/Management/UserManage.vue'),
                meta: { requiresAdmin: true }
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 白名单
const whiteList = ['/PriceShow', '/2k', '/2k/:tenantId?', '/2kmobile', '/2kmobile/:tenantId?', '/2k/v2/:tenantId?', '/2kmobile/v2/:tenantId?', '/2k-en', '/2k-en/:tenantId?', '/2kmobile-en', '/2kmobile-en/:tenantId?', '/login', '/MonitorDashboard', '/sso', '/h5/st']

const whiteListRegex = whiteList.map(whitePath => new RegExp(whitePath.replace(/:[^/]+/g, '[^/]+')));

router.beforeEach((to, from, next) => {
  NProgress.start();
  const token = getStore({ name: "access_token" });
  const isWhitePath = whiteList.includes(to.path) || whiteListRegex.some(regex => regex.test(to.path));

  // 检查路由是否需要管理员租户权限
  if (to.meta.requiresAdmin) {
    const isAdminTenant = getStore({ name: "isAdminTenant" });
    if (!isAdminTenant) {
      next({ path: '/Management/PriceManage' });
      NProgress.done();
      return;
    }
  }
  if (isWhitePath) {
    next();
  } else if (token) {
    next();
  } else {
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
});

router.afterEach(() => {
  NProgress.done();
});

router.onError(() => {
  NProgress.done();
});

export default router
